import { useAllAllowedActionsList, useMyAllowedActionsList } from './permissions.queries';

export function usePermissionsMatrix(projectID: string) {
  const allActions = useAllAllowedActionsList();
  const myActions = useMyAllowedActionsList(projectID);

  return (allActions.data || []).map((action) => ({
    action,
    isMyAction: (myActions.data || []).includes(action)
  }));
}
